import { createReducer, on } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import deepEqual from 'NewAngular/utils/equal/deep-equal';
import { deleteAIEventSummary, setAIEventSummary } from './ai-summary-events.actions';
export const aiSummaries = createReducer([], on(setAIEventSummary, (state, { calc, startDate, endDate, securityId }) => {
    const newState = cloneDeep(state);
    const partialEvents = cloneDeep(state).map((item) => ({
        startDate: item.startDate,
        calc: item.calc,
        securityId: item.securityId,
    }));
    const startDateSummary = { calc, securityId, startDate };
    // start date event can only exist once for same calc and securityId.
    const eventIndex = partialEvents.findIndex((event) => deepEqual(event, startDateSummary));
    if (eventIndex === -1) {
        newState.push({ calc, securityId, startDate, endDate });
    }
    else {
        newState[eventIndex] = { calc, securityId, startDate, endDate };
    }
    return newState;
}), on(deleteAIEventSummary, (state, { calc, startDate, endDate, securityId }) => {
    const newState = cloneDeep(state);
    const deleteSummary = { calc, startDate, endDate, securityId };
    return newState.filter((item) => !deepEqual(item, deleteSummary));
}));
